import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import type { CustomFieldDefinition } from "@/types/customFields";

interface CustomFieldInputsProps {
  definitions: CustomFieldDefinition[];
  values: Record<string, string>;
  onChange: (fieldKey: string, value: string) => void;
  idPrefix: string;
}

export function CustomFieldInputs({
  definitions,
  values,
  onChange,
  idPrefix,
}: CustomFieldInputsProps) {
  if (definitions.length === 0) return null;

  return (
    <div className="sm:col-span-2 space-y-3 pt-2 border-t">
      <p className="text-sm font-medium text-[#1e3a4f]">Custom fields</p>
      {definitions.map((field) => {
        const inputId = `${idPrefix}-${field.fieldKey}`;
        const value = values[field.fieldKey] ?? "";

        if (field.fieldType === "boolean") {
          return (
            <div key={field.id} className="flex items-center justify-between gap-4">
              <Label htmlFor={inputId}>
                {field.fieldLabel}
                {field.required ? " *" : ""}
              </Label>
              <Switch
                id={inputId}
                checked={value === "true"}
                onCheckedChange={(checked) => onChange(field.fieldKey, checked ? "true" : "false")}
              />
            </div>
          );
        }

        if (field.fieldType === "select") {
          return (
            <div key={field.id} className="space-y-1.5">
              <Label htmlFor={inputId}>
                {field.fieldLabel}
                {field.required ? " *" : ""}
              </Label>
              <Select
                id={inputId}
                value={value}
                onChange={(e) => onChange(field.fieldKey, e.target.value)}
                required={field.required}
              >
                {!field.required && <option value="">—</option>}
                {field.options.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </Select>
            </div>
          );
        }

        return (
          <div key={field.id} className="space-y-1.5">
            <Label htmlFor={inputId}>
              {field.fieldLabel}
              {field.required ? " *" : ""}
            </Label>
            <Input
              id={inputId}
              type={field.fieldType === "number" ? "number" : field.fieldType === "date" ? "date" : "text"}
              value={value}
              onChange={(e) => onChange(field.fieldKey, e.target.value)}
              required={field.required}
            />
          </div>
        );
      })}
    </div>
  );
}
